var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "about-us" },
        [
          _c(
            "el-container",
            { staticClass: "d-flex-column" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [_vm._v(" ")]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("h1", [_vm._v("About Us")]),
                    _c("p", [
                      _vm._v(
                        "We are Maren Solutions, one of the bespoke in-house software development company backed by Saudi’s leading Business Group. We design intelligent, cost-effective and intuitive web applications, desktop applications and mobile apps that help streamline process for new businesses"
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-container",
        { staticClass: "d-flex-column p-tb50" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("h2", [_vm._v("Our Methodology")]),
                _c("p", [
                  _vm._v("We adopt customised agile methodology with "),
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v("scrum practice which nourishes our products to be")
                  ]),
                  _vm._v(" implemented within stiplulated time.")
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "maren-believe" },
        [
          _c(
            "el-container",
            { staticClass: "d-flex-column" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c("el-col", { attrs: { span: 14 } }, [
                    _c("h2", [
                      _vm._v("We believe that we can "),
                      _c("span", { staticClass: "d-block" }, [
                        _vm._v("add value in the below ways:")
                      ])
                    ]),
                    _c("ul", { staticClass: "maren-believe-list" }, [
                      _c("li", [
                        _vm._v(
                          "Quick-ramp-up to understand the product due to domain knowledge within Maren"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Ability to participate and even lead requirement analysis for domains we have expertise in."
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Creating delivery roadmap to meet  product requirements."
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Utilize our talent pool to work with cutting-edge technologies."
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Analytical QA team to deliver bug-free products."
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Ability to adopt agile development methodologies to work with changing business needs and providing visibility with short development cycles with more frequent milestones"
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          "Provide support post deployement of our products"
                        )
                      ])
                    ])
                  ]),
                  _c(
                    "el-col",
                    { staticClass: "text-right", attrs: { span: 10 } },
                    [
                      _c("img", {
                        staticClass: "img-responsive",
                        attrs: {
                          src: require("../../../public/img/aboutus/methedology.png"),
                          alt: "Believe"
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-container", { staticClass: "d-flex-column" }, [
        _c("div", { staticClass: "p-tb100 d-flex-j-a-center" }, [
          _c("div", { staticClass: "p-dev-outer" }, [
            _c("div", { staticClass: "p-dev" }, [
              _c("span", { staticClass: "p-dev-tit" }, [
                _vm._v("Product "),
                _c("span", { staticClass: "d-block" }, [_vm._v("Development")])
              ])
            ])
          ]),
          _c("ul", { staticClass: "prod-list" }, [
            _c("li", [_vm._v("Requirement Planning")]),
            _c("li", { staticClass: "yellow" }, [_vm._v("Analysis")]),
            _c("li", { staticClass: "pink" }, [_vm._v("Design")]),
            _c("li", { staticClass: "dark-blue" }, [
              _vm._v("Review & Approval")
            ]),
            _c("li", { staticClass: "ciyan" }, [_vm._v("Coding")]),
            _c("li", { staticClass: "purple" }, [_vm._v("QA")]),
            _c("li", { staticClass: "blue" }, [_vm._v("Go Live & Support")])
          ])
        ]),
        _c("hr"),
        _c(
          "div",
          { staticClass: "core-values" },
          [
            _c("h2", [_vm._v("Our Core Values")]),
            _c(
              "el-row",
              { staticClass: "careers-grid", attrs: { gutter: 30 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-card",
                      { staticClass: "core-bg", attrs: { shadow: "never" } },
                      [
                        _c("h4", [_vm._v("Continue to grow")]),
                        _c("p", [
                          _vm._v(
                            "We keep learning, teaching, and growing individually, as a company and as a community."
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-card",
                      {
                        staticClass: "core-bg bg-white",
                        attrs: { shadow: "never" }
                      },
                      [
                        _c("h4", [_vm._v("Lead with passion")]),
                        _c("p", [
                          _vm._v(
                            "We love what we do and we do what we love. We are driven, take ownership for our work, and hold each other responsible."
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-card",
                      { staticClass: "core-bg", attrs: { shadow: "never" } },
                      [
                        _c("h4", [_vm._v("Positive vibes")]),
                        _c("p", [
                          _vm._v(
                            "We are positive, respectful team players. We build each other up, and are always ready to go the extra mile to help one another. "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/Aboutus.vue?vue&type=template&id=a02a7078&
// module id = 561
// module chunks = 7